import React from 'react'
import pt from 'prop-types'
import { Link } from 'react-router-dom'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { openMod } from '../../modules/mods'

const LinkWithLogin = ({ to, success, openMod, user, className, children }) => (
  <Link
    to={to || ''}
    className={className}
    onTouchStart={e => {
      /* Helps to fire onClick on mobile. Don't remove it */
    }}
    onClick={e => {
      !e.stopPropagation() &&
        !user.data &&
        !e.preventDefault() &&
        openMod({ type: 'signup', nextLocation: to, success })
    }}
  >
    {children}
  </Link>
)

LinkWithLogin.propTypes = {
  to: pt.string,
  className: pt.string,
  openMod: pt.func,
  success: pt.func,
  user: pt.shape({}),
  children: pt.node
}

export default connect(
  state => ({ user: state.user }),
  dispatch => ({
    openMod: bindActionCreators(openMod, dispatch)
  })
)(LinkWithLogin)
